import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "RecommendationsContainer" }
const _hoisted_2 = ["data-identifier", "data-filter-countries", "data-filter-disciplines", "data-filter-level"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "OtherInterestingForYou" }, "Interesting programmes for you", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "Recommendations",
        "data-identifier": _ctx.dataIdentifier,
        "data-recommendation-type": "programmes",
        "data-template": "carousel",
        "data-page": "search",
        "data-filter-countries": _ctx.countryFilterValues,
        "data-filter-disciplines": _ctx.selectedParentDiscipline,
        "data-filter-level": _ctx.portalType
      }, null, 8 /* PROPS */, _hoisted_2)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}